export interface TimelineLaneItem {
  id: string;
  start: number;
  end: number;
}

/**
 * Packs overlapping overlay windows into the smallest possible set of lanes.
 * Touching ranges (end === next start) may reuse the same lane.
 */
export function packTimelineLanes<T extends TimelineLaneItem>(items: readonly T[]): T[][] {
  const sorted = [...items].sort(
    (left, right) => left.start - right.start || left.end - right.end || left.id.localeCompare(right.id)
  );
  const lanes: T[][] = [];

  for (const item of sorted) {
    const lane = lanes.find((candidate) => {
      const last = candidate[candidate.length - 1];
      return !last || last.end <= item.start;
    });

    if (lane) lane.push(item);
    else lanes.push([item]);
  }

  return lanes;
}
